// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"505":"73a26f6f","618":"03c8c5f0","891":"4b0ec9d5"}[chunkId] + ".chunk.css";
};